<template>
  <div>
    <basic-container>
      <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
        @search-change="searchChange" @refresh-change="refreshChange(page)" @row-save="handleSave"
        @row-update="handleUpdate" @selection-change="handleSelectionChange" @size-change="pageSizeChange"
        @current-change="pageChange">
        <template slot="menuLeft">
          <el-button type="text" icon="el-icon-download" size="mini" plain
            @click.stop="downloadExcelWorkOrder">下载Excel</el-button>
          <el-button type="text" icon="el-icon-download" size="small" plain
            @click.stop="downloadCode({ type: 2 })">下载防水报单通用码</el-button>
          <el-button type="text" icon="el-icon-download" size="mini" plain
            @click.stop="downloadExcelActualArea">下载防水财务Excel</el-button>
        </template>
        <template slot-scope="scope" slot="menuBtn">
          <el-button type="text" icon="el-icon-view" size="small" plain @click.stop="handleView(scope.row)">查看
          </el-button>
          <el-button type="text" icon="el-icon-edit" size="small" plain
            @click.stop="handleEdit(scope.row, scope.index)">编辑
          </el-button>
          <!-- <el-button type="text" icon="el-icon-view" size="small" plain
            @click.stop="toViewOrder(scope.row)">查看工单</el-button> -->
          <el-button type="text" icon="el-icon-document" size="small" plain @click.stop="handleViewStage(scope.row)">工单
          </el-button>
          <el-button type="text" icon="el-icon-plus" size="small" plain
            v-show="scope.row.status == 'WAIT_AUDIT' && scope.row.reference"
            @click.stop="handleRebates(scope.row)">待返利</el-button>
          <!-- <el-button type="text" icon="el-icon-download" size="small" plain
            v-if="!scope.row.deliveryOrderId || scope.row.orderStatus == 'WAIT_FOR_ASSIGN'"
            @click.stop="handleDelivery(scope.row)">
            {{ scope.row.deliveryOrderId ? '修改提货单' : '生成提货单' }}
          </el-button> -->
          <!-- 指派监理按钮，只在待指派状态显示 -->
          <el-button type="text" icon="el-icon-edit" size="small" plain
            v-if="permission.JOINS_SALES_CLOUD_EDIT_MERCHANTS && scope.row.orderStatus == 'WAIT_FOR_ASSIGN'"
            @click.stop="handleAssign(scope.row, scope.index)">指派监理
          </el-button>
          <el-button type="text" icon="el-icon-edit" size="small" plain
            v-if="permission.JOINS_SALES_CLOUD_EDIT_MERCHANTS"
            @click.stop="handleAssignEngineerStage(scope.row)">分阶段指派工程师
          </el-button>
          <!-- <el-button type="text" icon="el-icon-view" size="small"
            v-if="scope.row.engineeringOrderId && scope.row.orderStatus !== 'WAIT_DISTRIBUTE' || !scope.row.shopId"
            plain @click.stop="viewAcceptance(scope.row)">查看验收单</el-button>
          <el-button type="text" icon="el-icon-edit" size="small" v-else plain
            @click.stop="handleAcceptance(scope.row)">生成验收单</el-button> -->
          <!-- <el-button type="text" icon="el-icon-view" size="small" plain
            v-if="scope.row.deliveryOrderId && scope.row.orderStatus != 'WAIT_FOR_ASSIGN'"
            @click.stop="viewDelivery(scope.row)">查看提货单</el-button> -->
        </template>
        <template slot-scope="scope" slot="menu">
          <!-- 动态按钮 -->
          <el-button type="text" icon="el-icon-news" @click="handleClick(scope.row)" :loading="isLoading" size="mini">
            {{ scope.row.stepName }}
          </el-button>
          <!-- <el-button type="text" size="small" icon="el-icon-edit"
            @click.stop="openWaterproofAreaDialog(scope.row)">面积配置</el-button> -->
        </template>
        <template slot-scope="scope" slot="orderStatus">
          <el-tag v-if="scope.row.orderStatus == 'WAIT_FOR_DELIVERY'" type="warning">待提货</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'WAIT_INSTALL'" type="warning">服务中</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'WAIT_ACCEPT'" type="warning">服务中</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'INSTALLED'" type="success">已安装</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'WAIT_FOR_ASSIGN'" type="warning">待指派</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'WAIT_DISTRIBUTE'" type="warning">待指派</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'WAIT_FOR_DELIVERY_SECOND'" type="warning">待二次提货</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'COMPLETE'" type="info">已完成</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'PARTIAL_INSTALLATION'" type="warning">部分安装</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'TO_BE_EVALUATED'" type="warning">待评价</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'IN_SERVICE'" type="warning">服务中</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'PARTIAL_REFUND'" type="danger">部分退款</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'REFUND_PAY'" type="danger">已退款</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'TO_BE_THE_FINAL'" type="warning">待终审</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'TO_BE_ACCEPTED'" type="warning">待验收</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'UNDER_ACCEPTANCE'" type="warning">验收中</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'ACCEPTANCE_COMPLETED'" type="success">已验收</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'TO_BE_CONFIRMED'" type="success">待确认</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'WAIT_BALANCE_PAYMENT'" type="danger">待付尾款</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'WAIT_INSTALL_SECOND'" type="warning">施工中</el-tag>
        </template>
        <template slot="picUrlForm">
          <ImageUpload action="#" :multiple="true" :limit="5" @uploaded="handleUploaded" :uploaded-images="picUrl" />
        </template>
        <template slot-scope="scope" slot="picUrl">
          <viewer :images="formmaterImage(scope.row.picUrl)">
            <img v-for="src in formmaterImage(scope.row.picUrl)" :src="src" :key="src" width="20">
          </viewer>
        </template>
      </avue-crud>
      <!-- 提货单弹窗 -->
      <el-dialog title="生成提货单" :visible.sync="dialogVisible" width="50%" :close-on-click-modal="false">
        <el-form :model="tabelObj" :rules="rules" label-width="100px" ref="tabelObj">
          <el-row>
            <!-- WarehouseList可筛选的前仓下拉选择 -->
            <el-col :span="12">
              <el-form-item label="前仓" prop="warehouseId">
                <el-select v-model="tabelObj.warehouseId" placeholder="请选择前仓">
                  <el-option v-for="item in WarehouseList" :key="item.id" :label="item.warehouseName" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 远程搜索工程师 -->
            <el-col :span="12">
              <el-form-item label="工程师" prop="engineerId" required>
                <el-select v-model="tabelObj.engineerId" placeholder="请选择工程师" filterable remote
                  :remote-method="handleRemote" clearable>
                  <el-option v-for="item in users" :key="item.id" :label="item.realName" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancel">取 消</el-button>
          <el-button type="primary" @click="confirm">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="生成验收单" :visible.sync="dialogAcceptanceVisible" width="50%" :close-on-click-modal="false">
        <el-form :model="superiorEr" :rules="rules" label-width="100px" ref="superiorEr">
          <el-row>
            <!-- 远程搜索工程师 -->
            <el-col :span="12">
              <el-form-item label="工程师" prop="engineerId" required>
                <el-select v-model="superiorEr.engineerId" placeholder="请选择工程师" filterable remote
                  :remote-method="handleRemote" clearable>
                  <el-option v-for="item in users" :key="item.id" :label="item.realName" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelHandleAcceptance">取 消</el-button>
          <el-button type="primary" @click="confirmHandleAcceptance">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 输入框对话框 -->
      <el-dialog :title="currentDialogTitle" :visible.sync="isDialogVisible" width="30%">
        <div v-if="isInputVisible">
          <el-input v-model="inputValue" placeholder="请输入内容" style="width: 100%; margin-bottom: 10px;"></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isDialogVisible = false" icon="el-icon-close">取 消</el-button>
          <el-button type="primary" @click="submitInput" icon="el-icon-check" :loading="isLoading">确 定</el-button>
        </span>
      </el-dialog>
      <viewOrder :visibleOrder.sync="viewOrderVisible" :orderId="orderId" :evaluateInfo="evaluateInfo" :id="idNow"
        @refresh="handleList" />
      <!-- <viewAreaOrder :visibleOrder.sync="viewOrderVisible" :orderId="orderId" :declarationFlag="1"
        :totalPrice="totalPrice" :evaluateInfo="evaluateInfo" :id="idNow" @refresh="handleList" /> -->
      <viewAcceptanceOrder :visibleAcceptanceOrder.sync="viewAcceptanceVisible" :orderId="engineeringOrderId"
        :id="idNow" @refresh="handleList" />
      <viewWaterProofStage :visibleStage.sync="viewStageVisible" :orderId="idNow" :status="wforderStatus" :id="idNow"
        @refresh="handleList" @openViewOrder="handleOpenViewOrder" />
      <!-- 指派监理弹窗 -->
      <el-dialog title="指派监理" :visible.sync="dialogVisible1" width="500px" :close-on-click-modal="false">
        <div v-if="loadingEngineers">加载中...</div>
        <el-form v-else :model="assignForm" :rules="rules1" ref="assignForm">
          <el-form-item label="选择监理" prop="engineeringSupervisor">
            <el-select v-model="assignForm.engineeringSupervisor" placeholder="请选择监理" filterable>
              <el-option v-for="engineer in engineers" :key="engineer.userId" :label="engineer.username"
                :value="engineer.userId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancel1">取消</el-button>
          <el-button type="primary" @click="saveInfo">确认指派</el-button>
        </span>
      </el-dialog>
      <el-dialog title="防水面积配置" :visible.sync="waterproofAreaDialogVisible" width="50%" :close-on-click-modal="false">
        <el-card shadow="never" style="margin-bottom: 10px;">
          <div slot="header" style="font-weight:bold;">添加区域面积配置</div>
          <el-form :model="areaForm" label-width="70px" style="margin-top: 20px;">
            <el-form-item label="新增配置">
              <el-select v-model="areaForm.name" placeholder="请选择区域名称" style="width: 200px;">
                <el-option v-for="item in areaNameOptions" :key="item" :label="item" :value="item" />
              </el-select>
            </el-form-item>
            <el-form-item label="面积(㎡)">
              <el-input v-model="areaForm.area" type="number" placeholder="请输入面积" style="width: 200px;" />
            </el-form-item>
            <el-form-item align="right">
              <el-button type="text" @click="addWaterproofArea" icon="el-icon-plus">添加</el-button>
            </el-form-item>
          </el-form>
          <el-card shadow="never" style="margin-bottom: 10px;">
            <div slot="header" style="font-weight:bold;">已添加区域面积配置</div>
            <el-table :data="waterproofAreaList" style="width: 100%; margin-top: 20px;">
              <el-table-column prop="name" label="名称" width="120" />
              <el-table-column prop="area" label="面积(㎡)" width="150">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.area" size="mini" @input="onAreaInput(scope.row)" type="number" />
                </template>
              </el-table-column>
              <!-- <el-table-column label="累计扣除面积(㎡)" width="120">
                <template slot-scope="scope">
                  {{ scope.row.subArea || '0.00' }}
                </template>
              </el-table-column> -->
              <el-table-column label="操作" width="180">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="deleteWaterproofArea(scope.$index)">删除</el-button>
                  <!-- <el-button type="text" size="small" @click="openDeductAreaDialog(scope.row, scope.$index)">扣除面积</el-button> -->
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </el-card>
        <el-card shadow="never" style="margin-bottom: 10px;">
          <div slot="header" style="font-weight:bold;">工单动态表单配置</div>
          <el-table :data="dynamicFormList" style="width: 100%;">
            <el-table-column prop="fieldName" label="字段名称" width="150" />
            <el-table-column prop="fieldValue" label="字段值">
              <template slot-scope="scope">
                <el-input v-model="scope.row.fieldValue" size="mini"
                  :type="scope.row.inputType === 'number' ? 'number' : 'text'" />
              </template>
            </el-table-column>
            <el-table-column prop="inputType" label="类型" width="100">
              <template slot-scope="scope">
                {{ scope.row.inputType === 'number' ? '数字' : '文本' }}
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        <span slot="footer" class="dialog-footer">
          <el-button @click="waterproofAreaDialogVisible = false" icon="el-icon-close">取 消</el-button>
          <el-button type="primary" @click="submitWaterproofArea" icon="el-icon-check" :loading="isLoading">确
            定</el-button>
        </span>
      </el-dialog>
      <!-- 分阶段指派工程师弹窗 -->
      <assign-engineer-stage :visible.sync="assignEngineerVisible" :order-id="assignEngineerOrderId" :root-depart-id="rootDepartmentId" @refresh="handleList" />

      <!-- <el-dialog title="扣除面积" :visible.sync="deductAreaDialogVisible" width="500px" @close="onDeductAreaDialogClose">
        <div>
          <el-form label-width="90px">
            <el-form-item label="图形类型">
              <el-select v-model="deductAreaForm.typeIndex" placeholder="请选择">
                <el-option v-for="(item, idx) in deductAreaTypeOptions" :key="idx" :label="item" :value="idx" />
              </el-select>
            </el-form-item>
            <template v-if="deductAreaForm.typeIndex === 0">
              <el-form-item label="长(m)">
                <el-input v-model="deductAreaForm.length" @input="onDeductAreaInput('length')" type="number" />
              </el-form-item>
              <el-form-item label="宽(m)">
                <el-input v-model="deductAreaForm.width" @input="onDeductAreaInput('width')" type="number" />
              </el-form-item>
            </template>
            <template v-if="deductAreaForm.typeIndex === 1">
              <el-form-item label="半径(m)">
                <el-input v-model="deductAreaForm.radius" @input="onDeductAreaInput('radius')" type="number" />
              </el-form-item>
            </template>
            <template v-if="deductAreaForm.typeIndex === 2">
              <el-form-item label="底(m)">
                <el-input v-model="deductAreaForm.base" @input="onDeductAreaInput('base')" type="number" />
              </el-form-item>
              <el-form-item label="高(m)">
                <el-input v-model="deductAreaForm.height" @input="onDeductAreaInput('height')" type="number" />
              </el-form-item>
            </template>
            <template v-if="deductAreaForm.typeIndex === 3">
              <el-form-item label="上底(m)">
                <el-input v-model="deductAreaForm.topBase" @input="onDeductAreaInput('topBase')" type="number" />
              </el-form-item>
              <el-form-item label="下底(m)">
                <el-input v-model="deductAreaForm.bottomBase" @input="onDeductAreaInput('bottomBase')" type="number" />
              </el-form-item>
              <el-form-item label="高(m)">
                <el-input v-model="deductAreaForm.trapHeight" @input="onDeductAreaInput('trapHeight')" type="number" />
              </el-form-item>
            </template>
            <template v-if="deductAreaForm.typeIndex === 4">
              <el-form-item label="自定义面积">
                <el-input v-model="deductAreaForm.customArea" @input="onDeductAreaInput('customArea')" type="number" />
              </el-form-item>
            </template>
            <el-form-item label="当前面积">
              <span>{{ deductAreaForm.area }} ㎡</span>
              <el-button type="primary" size="mini" @click="addDeductArea">新增</el-button>
            </el-form-item>
          </el-form>
          <el-table :data="tempDeductAreaList" size="mini" style="margin-bottom:10px;">
            <el-table-column prop="label" label="描述" />
            <el-table-column prop="area" label="面积(㎡)" width="100" />
            <el-table-column label="操作" width="60">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="removeDeductArea(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align:right;font-weight:bold;">累计扣除面积：{{ tempTotalDeductArea }} ㎡</div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="deductAreaDialogVisible = false">关闭</el-button>
        </span>
      </el-dialog> -->
      <!-- 绑定经营主体弹窗 -->
      <el-dialog title="请绑定经营主体" :visible.sync="businessEntityDialogVisible" width="700px" :close-on-click-modal="false">
        <div class="business-entity-dialog-content">
          <!-- 店铺信息 -->
          <el-form :model="businessEntityForm" label-width="100px" style="margin-bottom: 20px;">
            <el-form-item label="店铺名称">
              <el-input v-model="currentShopName" disabled></el-input>
            </el-form-item>
            <el-form-item label="店铺电话">
              <el-input v-model="currentShopMobile" disabled></el-input>
            </el-form-item>
            <el-form-item label="施工地址">
              <el-input v-model="currentCustomAddress" disabled></el-input>
            </el-form-item>
            <el-form-item label="经营主体" prop="businessEntityId">
              <el-select v-model="businessEntityForm.businessEntityId" placeholder="请选择经营主体" filterable clearable style="width: 100%;"
                :remote-method="handleBusinessEntityRemoteSearch" remote>
                <el-option v-for="item in businessEntityList" :key="item.id" :label="item.entityName" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="text" icon="el-icon-close" @click="businessEntityDialogVisible = false">取消</el-button>
          <el-button type="text" @click="confirmBusinessEntityBinding" icon="el-icon-check">确定绑定</el-button>
        </span>
      </el-dialog>
    </basic-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { resolveUrlPath } from "@/util/util";
import { waterProofTableOption } from "@/const/work/waterProof/merchantsOption";
import {
  getAgentList, addDeliveryOrder, getDeliveryOrder, updateDeliveryOrder, findWaterProof, addWaterProof, editWaterProof, delWaterProof,
  findWaterProofAll, downloadExcelCustomsDeclaration, handleRebates, getDownloadCode,
  getRootDepartmentId, putNextStep, createAcceptanceOrder, updateAcceptanceOrder, addAreaConfig,
  addAreaconfigEd, downloadExcelActualArea
} from "@/api/work/waterProof/merchants"
import { getWarehouseList, } from "@/api/salesCloud/warehouse";
import { findUserList } from "@/api/work/projectService";
import { evaluateInfoView } from "@/api/salesCloud/preFilter";
import { findDataSourceFields } from "@/api/work/dynamicForm";
// 导入指派监理相关的API
import { findBindEngineer, addBindEngineer, findEngineer } from "@/api/work/waterProof/merchants";
import { getBusinessEntityList, addShopEntityBind } from '@/api/salesCloud/businessEntity/businessEntity';
import ImageUpload from "@/components/imageUpload/ImageUpload";
import viewAreaOrder from "./components/viewAreaOrder.vue";
import viewAcceptanceOrder from "./components/viewAcceptanceOrder.vue";
import viewWaterProofStage from "./components/viewWaterProofStage.vue";
import viewOrder from "./components/viewOrder.vue";
import assignEngineerStage from "./components/assignEngineerStage.vue";
export default {
  name: "waterProof",
  components: {
    ImageUpload,
    viewAreaOrder,
    viewAcceptanceOrder,
    viewWaterProofStage,
    viewOrder,
    assignEngineerStage
  },
  data() {
    return {
      tableOption: waterProofTableOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      tabelObj: {},
      tempInfo: {},
      users: [],
      wforderStatus: "",
      rules: {
        engineerId: [
          { required: true, message: "请选择工程师", trigger: "change" }
        ],
      },
      agentList: [],
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 30 //每页显示多少条
      },
      dialogVisible: false,
      viewOrderVisible: false,
      evaluateInfo: false,
      totalPrice: 0,
      WarehouseList: [],
      downloadData: {},
      rootDepartmentId: "",
      superiors: [],
      superior: {},
      picUrl: "",
      fileList: [],
      orderId: "",
      engineeringOrderId: "",
      idNow: "",
      steps: new Map([
        [1, { label: "是否派单", value: '', hasInput: true, dialogTitle: "请输入施工员" }],
        [2, { label: "涂料已刷", value: '', hasInput: false, dialogTitle: "" }],
        [3, { label: "闭水", value: '', hasInput: true, dialogTitle: "请输入验收员" }],
        [4, { label: "是否审核", value: '', hasInput: false, dialogTitle: "" }],
      ]),
      inputValue: "", // 输入框的值
      isDialogVisible: false, // 控制对话框显示
      dialogAcceptanceVisible: false, // 控制框显示
      viewAcceptanceVisible: false,
      isLoading: false, // 按钮加载状态
      superiorEr: {
        engineerId: "",
        declarationId: "",
      },
      rowInfo: {},
      currentRow: {}, // 当前选中的行数据
      waterproofAreaDialogVisible: false,
      viewStageVisible: false,
      areaForm: {
        name: '',
        area: '',
      },
      areaNameOptions: [],
      waterproofAreaList: [],
      dynamicFormList: [], // 新增的动态表单数据
      deductAreaDialogVisible: false, // 扣除面积弹窗
      currentDeductAreaIndex: null,   // 当前编辑的区域索引
      tempDeductAreaList: [],         // 临时扣除面积项
      tempTotalDeductArea: "0.00",    // 临时累计扣除面积
      deductAreaForm: {               // 扣除面积表单
        typeIndex: 0,
        length: "",
        width: "",
        radius: "",
        base: "",
        height: "",
        customArea: "",
        area: "0.00",
        topBase: "",
        bottomBase: "",
        trapHeight: "",
      },
      deductAreaTypeOptions: ["矩形", "圆形", "三角形", "梯形", "异形"],
      hasSetDefaultAgent: false,
      // 指派监理相关数据
      dialogVisible1: false,
      loadingEngineers: false,
      engineers: "",
      assignForm: {
        declarationId: '',
        engineeringSupervisor: ''
      },
      rules1: {
        engineeringSupervisor: [
          {
            required: true,
            message: "请选择监理",
            trigger: "change"
          }
        ]
      },
      // 经营主体绑定相关
      businessEntityDialogVisible: false,
      businessEntityList: [],
      businessEntityForm: {
        businessEntityId: ''
      },
      currentShopId: null,
      currentShopName: '',
      currentShopMobile: '',
      currentCustomAddress: '',
      businessEntityLoading: false,
      // 分阶段指派工程师相关
      assignEngineerVisible: false,
      assignEngineerOrderId: ''
    };
  },
  created() {
    this.getAgentList();
    this.handleList();
    this.handleWarehouseList();
    this.getEngineers(); // 获取所有监理
  },
  watch: {
    agentList(newVal) {
      if (!this.hasSetDefaultAgent && Array.isArray(newVal) && newVal.length) {
        const first = newVal[0];
        this.$nextTick(() => {
          if (this.$refs && this.$refs.crud && this.$refs.crud.searchForm) {
            if (!this.$refs.crud.searchForm.rootDepartId) {
              this.$set(this.$refs.crud.searchForm, 'rootDepartId', first.value);
              this.hasSetDefaultAgent = true;
              // 设定默认后触发一次查询，保证列表与默认代理商同步
              this.searchChange({ ...this.$refs.crud.searchForm });
            }
          }
        });
      }
    }
  },
  mounted() {
  },
  computed: {
    ...mapGetters(["permission"]),
    // 获取当前对话框标题
    currentDialogTitle() {
      const step = this.steps.get(this.rowInfo.step);
      return step ? step.dialogTitle : "";
    },
    // 判断是否需要输入框
    isInputVisible() {
      const step = this.steps.get(this.rowInfo.step);
      return step ? step.hasInput : false;
    },
  },
  props: [],
  methods: {
    // 获取代理商列表
    async getAgentList() {
      const res = await getAgentList();
      if (res.code == "200") {
        this.agentList = JSON.parse(res.data);
        // 将代理商列表转换为下拉选项
        this.agentList = this.agentList.map(item => ({
          ...item,
          label: item.company,
          value: item.id,
        }));
        // 按 prop 精准定位列，避免依赖固定下标
        const idx = Array.isArray(this.tableOption.column)
          ? this.tableOption.column.findIndex(col => col && col.prop === "rootDepartId")
          : -1;
        if (idx !== -1) {
          // 使用 $set 确保响应式更新 dicData
          this.$set(this.tableOption.column[idx], "dicData", this.agentList);
        }
      }
    },
    // 获取所有监理
    async getEngineers() {
      this.loadingEngineers = true;  // 启动加载状态
      const params = { type: "JOINS_ENGINEER", manager: "SUPERVISOR" ,page: 1,size: 100};
      try {
        const res = await findBindEngineer(params);
        if (res.code === "200") {
          this.engineers = JSON.parse(res.data).rows || [];
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        this.$message.error("获取监理失败");
      } finally {
        this.loadingEngineers = false;  // 请求完成后关闭加载状态
      }
    },
    // 处理指派监理的逻辑
    async handleAssign(row) {
      this.dialogVisible1 = true;
      this.assignForm = {
        declarationId: row.id,
        engineeringSupervisor: ''
      };
      // 获取当前工单已指派的监理信息
      await this.getEngineerByServiceOrderId(row.id);
    },
    saveInfo() {
      if (!this.assignForm.engineeringSupervisor) {
        this.$message.error("请选择监理");
        return;
      }
      this.$confirm("是否确认指派监理?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        addBindEngineer(this.assignForm).then((res) => {
          if (res.code == "200") {
            this.$message({
              type: "success",
              message: "指派成功!"
            });
            this.dialogVisible1 = false;
            this.handleList(); // 重新加载列表
          } else if (res.code == "24022061") {
            // 报单商家经营主体不存在，触发绑定弹窗
            this.$message.warning(res.message || '报单商家经营主体不存在，请设置经营主体！');
            // 获取当前行数据
            const currentRow = this.tableData.find(item => item.id === this.assignForm.declarationId);
            if (currentRow) {
              // 打开绑定经营主体弹窗
              this.openBusinessEntityDialog(currentRow.shopId, currentRow.shopName, currentRow.contactMobile, currentRow.customAddress);
            }
          } else {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error",
            });
          }
        });
      });
    },
    cancel1() {
      this.dialogVisible1 = false;
    },
    /**
     * @title 获取当前工单的监理信息
     * @param id 工单id
     * @description 根据工单id获取当前工单已指派的监理信息
     */
    async getEngineerByServiceOrderId(id) {
      const params = { declarationId: id, type: "WATERPROOF" };
      try {
        const res = await findEngineer(params);
        if (res.code === "200") {
          let data = JSON.parse(res.data).rows;
          if (data && data.length > 0) {
            // 设置已指派的监理
            this.assignForm.engineeringSupervisor = data[0].engineeringSupervisor || '';
          }
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        this.$message.error('获取监理数据失败');
      }
    },
    // 打开绑定经营主体弹窗
    openBusinessEntityDialog(shopId, shopName, shopMobile, customAddress) {
      this.currentShopId = shopId;
      this.currentShopName = shopName;
      this.currentShopMobile = shopMobile;
      this.currentCustomAddress = customAddress;
      this.businessEntityDialogVisible = true;
      this.getBusinessEntityList();
    },
    // 获取经营主体列表
    getBusinessEntityList(entityName = '') {
      this.businessEntityLoading = true;
      const params = {
        page: '1',
        size: '100', // 不分页，获取足够多的数据
        entityName: entityName
      };
      getBusinessEntityList(params)
        .then(res => {
          const data = JSON.parse(res.data);
          this.businessEntityList = data.rows || [];
        })
        .finally(() => {
          this.businessEntityLoading = false;
        });
    },
    // 经营主体远程搜索
    handleBusinessEntityRemoteSearch(query) {
      this.getBusinessEntityList(query);
    },
    // 确认绑定经营主体
    confirmBusinessEntityBinding() {
      if (!this.businessEntityForm.businessEntityId) {
        this.$message.error('请选择要绑定的经营主体');
        return;
      }
      if (!this.currentShopId) {
        this.$message.error('商户信息有误，请重试');
        return;
      }
      // 调用绑定接口
      const params = [{
        shopId: this.currentShopId,
        businessEntityId: this.businessEntityForm.businessEntityId,
        shopName: this.currentShopName,
        shopMobile: this.currentShopMobile
      }];
      addShopEntityBind(params)
        .then(res => {
          if (res.code == '200') {
            this.$message.success('绑定经营主体成功');
            this.businessEntityDialogVisible = false;
            // 重置状态
            this.businessEntityForm.businessEntityId = '';
            this.currentShopId = null;
            this.currentShopName = '';
            this.currentCustomAddress = '';
            this.currentShopMobile = '';
          } else {
            this.$message.error(res.message || '绑定经营主体失败');
          }
        });
    },
    // 处理打开viewOrder组件的事件
    handleOpenViewOrder() {
      this.toViewOrder(this.tempInfo);
    },
    // 处理分阶段指派工程师
    handleAssignEngineerStage(row) {
      this.assignEngineerOrderId = row.id;
      this.assignEngineerVisible = true;
    },
    toViewOrder(row) {
      // 先重置状态，确保显示新数据
      this.viewOrderVisible = false;
      this.evaluateInfo = false;
      this.orderId = '';
      this.idNow = '';
      this.totalPrice = 0;
      // 使用 nextTick 确保状态重置后再设置新值
      this.$nextTick(() => {
        this.viewOrderVisible = true;
        this.evaluateInfo = false;
        this.orderId = row.deliveryOrderId || ''
        this.idNow = row.id;
        this.totalPrice = row.totalPrice;
      });
    },
    async handleClick(row) {
      const step = this.steps.get(row.step);
      // step:4为已完成的情况不允许点击
      if (row.step > 4) {
        this.$message.error("已完成，不允许点击");
        return;
      }
      if (step.hasInput) {
        // 如果需要输入框，显示对话框
        this.isDialogVisible = true;
        this.rowInfo = row;
      } else {
        // 如果不需要输入框，直接请求并进入下一步
        await this.requestStep(row, '');
        //this.nextStep();
      }
    },
    async submitInput() {
      if (this.inputValue.trim()) {
        // 保存输入的值
        // 发送请求
        await this.requestStep(this.rowInfo, this.inputValue);
        // 清理输入框并关闭对话框
        this.inputValue = "";
        this.isDialogVisible = false;
        // 进入下一步
        //this.nextStep();
      } else {
        this.$message.error("请输入有效内容");
      }
    },
    async requestStep(row, val) {
      try {
        this.isLoading = true; // 开始加载
        var step = "";
        if (row.val) {
          step = row.step + ':' + row.val + "," + val
        } else {
          step = row.step + ':' + val
        }
        const params = {
          step: step,
          id: row.id
        };
        const res = await putNextStep(params);
        if (res.code === "200") {
          this.$message.success(`步骤 ${row.stepName} 完成`);
          this.handleList();
        } else {
          this.$message.error("请求失败，请重试");
        }
      } catch (error) {
        this.$message.error("请求失败，请重试");
      } finally {
        this.isLoading = false; // 停止加载
      }
    },
    // cancel取消
    cancel() {
      this.dialogVisible = false;
      // 清空表单
      this.tabelObj = {};
    },
    // confirm生成提货单
    confirm() {
      this.$refs["tabelObj"].validate((valid) => {
        if (valid) {
          let params = this.tabelObj;
          params.status = "WAIT_FOR_DELIVERY";
          if (params.deliveryOrderId) {
            // 先通过提货单id查询getDeliveryOrder
            getDeliveryOrder(params.deliveryOrderId).then((res) => {
              if (res.code == "200") {
                let data = JSON.parse(res.data).rows[0];
                params = { ...data, ...params };
                updateDeliveryOrder(params).then((res) => {
                  if (res.code == "200") {
                    this.$message({
                      showClose: true,
                      message: "修改提货单成功",
                      type: "success",
                    });
                    this.handleList();
                    this.dialogVisible = false;
                  } else {
                    this.$message({
                      showClose: true,
                      message: res.message,
                      type: "error",
                    });
                  }
                })
              }
            })
          } else {
            addDeliveryOrder(params).then((res) => {
              if (res.code == "200") {
                this.$message({
                  showClose: true,
                  message: "生成提货单成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "error",
                });
              }
            });
          }
          this.tabelObj = {};
          this.dialogVisible = false;
        } else {
          this.$message({
            showClose: true,
            message: "请填写完整信息",
            type: "error",
          });
        }
      });
    },
    // handleRemote远程搜索工程师
    handleRemote(query) {
      // eslint-disable-next-line no-control-regex
      if (/[^\x00-\xff]/.test(query)) {
        this.users = [];
        setTimeout(() => {
          let params = {
            type: "JOINS_ENGINEER",
            mobile: query,
          };
          findUserList(params).then((res) => {
            if (res.code == "200") {
              let data = JSON.parse(res.data);
              this.users = data
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error",
              });
            }
          });
        }, 200);
      } else if (/^\d{11}$/.test(query)) {
        this.users = [];
        setTimeout(() => {
          let params = {
            type: "JOINS_ENGINEER",
            mobile: query,
          };
          findUserList(params).then((res) => {
            if (res.code == "200") {
              let data = JSON.parse(res.data);
              this.users = data
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error",
              });
            }
          });
        }, 200);
      }
    },
    handleWarehouseList() {
      let params = {
        page: 1,
        size: 100,
      };
      getWarehouseList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.WarehouseList = data.rows;
      });
    },
    // 生成提货单
    handleDelivery(row) {
      // 打开生成提货单弹窗
      this.dialogVisible = true;
      this.tabelObj.deliveryOrderId = row.deliveryOrderId ? row.deliveryOrderId : "";
      this.tabelObj.shopId = row.shopId;
      this.tabelObj.declarationId = row.id;
      // 获取搜索表单中的rootDepartId（如果已选）
      if (this.$refs.crud && this.$refs.crud.searchForm && this.$refs.crud.searchForm.rootDepartId) {
        this.tabelObj.rootDepartId = this.$refs.crud.searchForm.rootDepartId;
      }
    },
    handleAcceptance(row) {
      this.dialogAcceptanceVisible = true;
      this.superiorEr.declarationId = row.id;
      this.superiorEr.contactsMobile = row.contactMobile;
      this.superiorEr.engineeringOrderId = row.engineeringOrderId
      this.superiorEr.type = "ACCEPTANCE";
    },
    viewAcceptance(row) {
      this.evaluateInfo = false;
      this.viewAcceptanceVisible = true;
      this.engineeringOrderId = row.engineeringOrderId;
      this.idNow = row.id;
    },
    handleViewStage(row) {
      this.tempInfo = row;
      this.idNow = row.id;
      this.wforderStatus = row.orderStatus;
      this.viewStageVisible = true;
    },
    confirmHandleAcceptance() {
      this.$refs["superiorEr"].validate((valid) => {
        if (valid) {
          var params = {
            ...this.superiorEr,
          }
          if (params.engineeringOrderId) {
            const params1 = {
              id: this.superiorEr.engineeringOrderId,
              engineerId: this.superiorEr.engineerId,
              status: 'WAIT_ACCEPT'
            };
            updateAcceptanceOrder(params1).then((res) => {
              if (res.code == "200") {
                this.$message({
                  showClose: true,
                  message: "生成验收单成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "error",
                });
              }
            });
          } else {
            createAcceptanceOrder(params).then((res) => {
              if (res.code == "200") {
                this.$message({
                  showClose: true,
                  message: "生成验收单成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "error",
                });
              }
            });
          }
          this.superiorEr = {};
          this.dialogAcceptanceVisible = false;
        } else {
          this.$message({
            showClose: true,
            message: "请填写完整信息",
            type: "error",
          });
        }
      });
    },
    cancelHandleAcceptance() {
      this.dialogAcceptanceVisible = false;
      this.superiorEr = {};
    },
    // 查看提货单
    viewDelivery(row) {
      // 查看
      let obj = {
        label: "查看提货单",
        value: "/work/eliveryOrder/view",
        query: { id: row.deliveryOrderId, type: row.type },
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label),
        query: obj.query,
      });
    },
    // 生成商家码并显示弹窗
    downloadCode(type) {
      this.$confirm("是否确认生成通用码?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        // 确保scene值有效
        if (!this.rootDepartmentId) {
          const res = await getRootDepartmentId();
          this.rootDepartmentId = res.data;
        }
        const data = {
          scene: this.rootDepartmentId,
          page: type.type == 1 ? "pages/waterProof/install/install" : "pages/waterProof/customer/customer",
          width: "340",
          clientType: "JOINS_MERCHANT",
        };
        getDownloadCode(data).then((response) => {
          // 提取文件名
          const filename = response.headers["content-disposition"].match(
            /filename=(.*)/
          )[1];
          // 将二进制流转为blob
          const blob = new Blob([response.data], {
            type: "application/octet-stream",
          });
          if (typeof window.navigator.msSaveBlob !== "undefined") {
            // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
            window.navigator.msSaveBlob(blob, decodeURI(filename));
          } else {
            // 创建新的URL并指向File对象或者Blob对象的地址
            const blobURL = window.URL.createObjectURL(blob);
            // 创建a标签，用于跳转至下载链接
            const tempLink = document.createElement("a");
            tempLink.style.display = "none";
            tempLink.href = blobURL;
            tempLink.setAttribute("download", decodeURI(filename));
            // 兼容：某些浏览器不支持HTML5的download属性
            if (typeof tempLink.download === "undefined") {
              tempLink.setAttribute("target", "_blank");
            }
            // 挂载a标签
            document.body.appendChild(tempLink);
            tempLink.click();
            document.body.removeChild(tempLink);
            // 释放blob URL地址
            window.URL.revokeObjectURL(blobURL);
            // 使用正确的参数刷新
            this.searchChange(this.downloadData);
          }
        });
      })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消生成通用码"
          });
        });
    },
    /**
     * @title 分类下拉框数据
     *
     **/
    handleSuperior() {
      findWaterProofAll().then((res) => {
        let data = JSON.parse(res.data)
        this.superiors = data
      })
    },
    handleUploaded(url) {
      // 只支持单张图片上传
      this.picUrl = url;
      this.tableLoading = false;
    },
    formmaterImage(row) {
      let str = new Array();
      JSON.stringify(row);
      if (row != null) {
        let picArray = row.split(",");
        for (let i = 0; i < picArray.length; i++) {
          str.push(picArray[i]);
        }
      }
      return str;
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage,
        params.size = pageSize
      findWaterProof(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.getStep();
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        this.tableLoading = false;
      })
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm
      params.page = page
      params.size = this.page.pageSize
      findWaterProof(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.getStep();
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      })
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage
      params.size = this.page.pageSize
      this.downloadData = params;
      findWaterProof(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.getStep();
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      })
    },
    downloadExcelWorkOrder() {
      let params = this.downloadData;
      if (!params) {
        this.$message.error("导出参数未定义，请先进行一次查询操作！");
        return;
      }
      downloadExcelCustomsDeclaration(params).then((response) => {
        // 提取文件名
        const filename = response.headers["content-disposition"].match(
          /filename=(.*)/
        )[1];
        // 将二进制流转为blob
        const blob = new Blob([response.data], {
          type: "application/octet-stream",
        });
        if (typeof window.navigator.msSaveBlob !== "undefined") {
          // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
          window.navigator.msSaveBlob(blob, decodeURI(filename));
        } else {
          // 创建新的URL并指向File对象或者Blob对象的地址
          const blobURL = window.URL.createObjectURL(blob);
          // 创建a标签，用于跳转至下载链接
          const tempLink = document.createElement("a");
          tempLink.style.display = "none";
          tempLink.href = blobURL;
          tempLink.setAttribute("download", decodeURI(filename));
          // 兼容：某些浏览器不支持HTML5的download属性
          if (typeof tempLink.download === "undefined") {
            tempLink.setAttribute("target", "_blank");
          }
          // 挂载a标签
          document.body.appendChild(tempLink);
          tempLink.click();
          document.body.removeChild(tempLink);
          // 释放blob URL地址
          window.URL.revokeObjectURL(blobURL);
          this.searchChange(params);
        }
      });
    },
    downloadExcelActualArea() {
      let params = this.downloadData;
      // 温馨提示：只会下载已提货的报单数据
      this.$confirm('温馨提示：只会下载已提货的报单数据', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        downloadExcelActualArea(params).then((response) => {
          // 提取文件名
          const filename = response.headers["content-disposition"].match(
            /filename=(.*)/
          )[1];
          // 将二进制流转为blob
          const blob = new Blob([response.data], {
            type: "application/octet-stream",
          });
          if (typeof window.navigator.msSaveBlob !== "undefined") {
            // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
            window.navigator.msSaveBlob(blob, decodeURI(filename));
          } else {
            // 创建新的URL并指向File对象或者Blob对象的地址
            const blobURL = window.URL.createObjectURL(blob);
            // 创建a标签，用于跳转至下载链接
            const tempLink = document.createElement("a");
            tempLink.style.display = "none";
            tempLink.href = blobURL;
            tempLink.setAttribute("download", decodeURI(filename));
            // 兼容：某些浏览器不支持HTML5的download属性
            if (typeof tempLink.download === "undefined") {
              tempLink.setAttribute("target", "_blank");
            }
            // 挂载a标签
            document.body.appendChild(tempLink);
            tempLink.click();
            document.body.removeChild(tempLink);
            // 释放blob URL地址
            window.URL.revokeObjectURL(blobURL);
            this.searchChange(params);
          }
        });
      }).catch(() => {
      })
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm
      params.page = page.currentPage
      params.size = page.pageSize
      findWaterProof(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.getStep();
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      })
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      // 清空表单
      this.cleanForm();
      this.$refs.crud.rowAdd();
    },
    handleView(row) {
      // 查看
      let obj = {
        label: "查看商户报单",
        value: "/work/waterProof/merchants/view",
        query: { id: row.id },
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label),
        query: obj.query,
      });
    },
    handleEdit(row) {
      // 去编辑
      let obj = {
        label: "编辑商户报单",
        value: "/work/waterProof/merchants/edit",
        query: { id: row.id ,number:row.number},
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label),
        query: obj.query,
      });
    },
    getStep() {
      for (var i = 0; i < this.tableData.length; i++) {
        let row = this.tableData[i];
        if (row.step == null || row.step == 0) {
          row.step = 0;
        } else {
          var step1 = row.step.split(":");
          row.step = step1[0];
          var val = step1[1];
          if (val) {
            row.val = val;
          } else {
            row.val = "";
          }
        }
        row.step = Number(row.step) + 1;
        if (row.step > this.steps.size) {
          row.stepName = "已完成";
        } else {
          row.stepName = this.steps.get(row.step).label;
        }
      }
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let parmas = {
        page: this.page.currentPage,
        size: this.page.pageSize
      }
      this.downloadData = parmas;
      findWaterProof(parmas).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.getStep();
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        getRootDepartmentId().then(res => {
          let data = res.data;
          this.rootDepartmentId = data;
        });
        this.tableLoading = false;
      })
      this.handleSuperior();
    },
    /**
     * @title cleanForm
     */
    cleanForm() {
      this.superior = {};
      this.superior.id = null;
      this.picUrl = "";
      this.fileList = [];
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      row.superiorId = this.superior.id;
      row.picUrl = this.picUrl;
      addWaterProof(row).then(response => {
        if (response.code == '200') {
          this.$message({
            showClose: true,
            message: "添加成功",
            type: "success"
          });
          this.cleanForm();
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error"
          })
        }
      }).catch(error => {
        this.loading = false
        this.$message({
          showClose: true,
          message: error,
          type: "error"
        })
      })
      done();
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange(val) {
      this.tableRow = val;
      /* this.$notify({
          showClose: true,
          message: JSON.stringify(val),
          type: 'success',
      }); */
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel() {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error"
        })
        return
      }
      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id)
          }
          delWaterProof(ids).then(response => {
            if (response.code == '200') {
              this.$message({
                showClose: true,
                message: "删除成功",
                type: "success"
              });
              this.handleList();
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error"
              })
            }
          }).catch(error => {
            this.loading = false
            this.$message({
              showClose: true,
              message: error,
              type: "error"
            })
          })
        })
        .catch(() => { });
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      row.superiorId = this.superior.id
      row.picUrl = this.picUrl;
      editWaterProof(row).then(response => {
        if (response.code == '200') {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success"
          });
          this.cleanForm();
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error"
          })
        }
      }).catch(error => {
        this.loading = false
        this.$message({
          showClose: true,
          message: error,
          type: "error"
        })
      })
      done();
    },
    handleRebates(row) {
      // 返利确认
      this.$confirm(`是否确认返利?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          handleRebates(row.id).then(response => {
            if (response.code == '200') {
              this.$message({
                showClose: true,
                message: "返利成功",
                type: "success"
              });
              this.handleList();
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error"
              })
            }
          }).catch(error => {
            this.loading = false
            this.$message({
              showClose: true,
              message: error,
              type: "error"
            })
          })
        })
    },
    handleDetail(row, index) {
      this.superior = {};
      this.superior.id = row.superiorId;
      this.picUrl = row.picUrl;
      this.$refs.crud.rowView(row, index)
    },
    addWaterproofArea() {
      const name = this.areaForm.name;
      if (!name) {
        this.$message.error("请选择区域名称");
        return;
      }
      if (!this.areaForm.area) {
        this.$message.error("请输入面积");
        return;
      }
      const area = parseFloat(this.areaForm.area);
      if (isNaN(area) || area <= 0) {
        this.$message.error("面积必须为大于0的数字");
        return;
      }
      // 如果是"其他"选项，需要用户输入具体名称
      let finalName = name;
      if (name === "其他") {
        this.$prompt('请输入区域名称', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /.+/,
          inputErrorMessage: '区域名称不能为空'
        }).then(({ value }) => {
          finalName = value;
          this.addAreaToList(finalName, area);
        }).catch(() => {
          // 用户取消输入
        });
      } else {
        this.addAreaToList(finalName, area);
      }
    },
    addAreaToList(name, area) {
      // 统计当前列表中已有的同名区域的最大编号
      const regex = new RegExp(`^${name}(\\d+)$`);
      let maxIndex = 0;
      this.waterproofAreaList.forEach(item => {
        const match = item.name.match(regex);
        if (match) {
          const num = parseInt(match[1], 10);
          if (num > maxIndex) maxIndex = num;
        }
      });
      const count = maxIndex + 1;
      // 添加到列表
      this.waterproofAreaList.push({
        name: `${name}${count}`,
        area: area.toFixed(2), // 确保面积保留两位小数
        subArea: "0.00", // 初始扣除面积为0
        jsonData: JSON.stringify([]) // 扣除面积的jsonData
      });
      // 清空表单
      this.areaForm = {
        name: '',
        area: '',
      };
    },
    onAreaInput(row) {
      // 自动计算面积
      row.area = parseFloat(row.area).toFixed(2);
    },
    deleteWaterproofArea(index) {
      // 删除防水面积配置
      this.waterproofAreaList.splice(index, 1);
    },
    submitWaterproofArea() {
      if (this.waterproofAreaList.length === 0) {
        this.$message.error("请添加防水面积配置");
        return;
      }
      // 校验其他配置至少填写一个
      const hasOther = this.dynamicFormList.some(item => item.fieldValue && item.fieldValue !== "");
      if (!hasOther) {
        this.$message.error("请填写至少一个其他配置");
        return;
      }
      const declarationId = this.currentRow.id;
      const areaParams = {
        declarationId,
        areaConfigList: this.waterproofAreaList.map(item => ({
          ...item,
          jsonData: Array.isArray(item.jsonData) ? JSON.stringify(item.jsonData) : item.jsonData
        }))
      };
      const otherParams = {
        declarationId,
        otherList: this.dynamicFormList
          .filter(item => item.fieldValue && item.fieldValue !== "") // 只提交有值的字段
          .map(item => ({
            id: item.id,
            fieldName: item.fieldName,
            fieldValue: item.fieldValue,
            inputType: item.inputType,
            declarationId
          }))
      };
      this.isLoading = true;
      Promise.all([
        addAreaConfig(areaParams),
        addAreaconfigEd(otherParams)
      ]).then(([res1, res2]) => {
        if (res1.code === '200' && res2.code === '200') {
          this.$message.success("防水面积配置提交成功");
          this.handleList();
        } else {
          this.$message.error(res1.message || res2.message || "提交失败");
        }
      }).catch(err => {
        this.$message.error(err.message || "提交失败");
      }).finally(() => {
        this.isLoading = false;
        this.waterproofAreaDialogVisible = false;
      });
    },
    openWaterproofAreaDialog(row) {
      this.currentRow = row;
      // areaConfigList 可能是后端返回的配置列表字段名，请根据实际字段名调整
      this.waterproofAreaList = row.areaConfigEngineer
        ? JSON.parse(JSON.stringify(row.areaConfigEngineer)).map(item => ({
          ...item,
          jsonData: typeof item.jsonData === 'string' ? item.jsonData : JSON.stringify(item.jsonData || [])
        }))
        : [];
      this.waterproofAreaDialogVisible = true;
      this.areaForm = {
        name: "",
        area: "",
      };
      // 区域名称选项初始化
      this.areaNameOptions = ["阳台", "卫生间", "厨房", "其他"];
      // 获取工单动态表单数据
      this.getDynamicFormData(row);
    },
    // 获取工单动态表单数据
    async getDynamicFormData(row) {
      try {
        // 获取动态控件类型
        const inputTypesRes = await findDataSourceFields();
        const inputTypes = JSON.parse(inputTypesRes.data);
        // 获取工单动态表单数据
        const params = {
          id: row.deliveryOrderId,
          code: 'WORK_WATERPROOF'
        };
        const res = await evaluateInfoView(params);
        if (res.code === "200") {
          const jsonData = JSON.parse(res.data);
          // 过滤出非图片字段，转换为动态表单格式
          this.dynamicFormList = jsonData.list
            .filter(item => item.inputType != '8') // 排除图片字段
            .map(item => ({
              id: item.id,
              fieldName: item.fieldName,
              fieldValue: item.value || "",
              inputType: this.getInputType(item.inputType, inputTypes)
            }));
        } else {
          // 如果获取失败，使用默认配置
          this.dynamicFormList = [
            { fieldName: "基坑数量", fieldValue: "", inputType: "number" },
            { fieldName: "丙纶面积", fieldValue: "", inputType: "number" },
            { fieldName: "涤纶面积", fieldValue: "", inputType: "number" },
            { fieldName: "增项", fieldValue: "", inputType: "text" },
            { fieldName: "回填面积", fieldValue: "", inputType: "number" },
            { fieldName: "二排数量", fieldValue: "", inputType: "number" },
            { fieldName: "模具", fieldValue: "", inputType: "text" },
            { fieldName: "楼层", fieldValue: "", inputType: "number" }
          ];
        }
      } catch (error) {
        // 使用默认配置
        this.dynamicFormList = [
          { fieldName: "基坑数量", fieldValue: "", inputType: "number" },
          { fieldName: "丙纶面积", fieldValue: "", inputType: "number" },
          { fieldName: "涤纶面积", fieldValue: "", inputType: "number" },
          { fieldName: "增项", fieldValue: "", inputType: "text" },
          { fieldName: "回填面积", fieldValue: "", inputType: "number" },
          { fieldName: "二排数量", fieldValue: "", inputType: "number" },
          { fieldName: "模具", fieldValue: "", inputType: "text" },
          { fieldName: "楼层", fieldValue: "", inputType: "number" }
        ];
      }
    },
    // 获取输入类型
    getInputType(inputType, inputTypes) {
      const type = inputTypes.find(item => item.id == inputType);
      if (type && type.name) {
        return type.name === '数字' ? 'number' : 'text';
      }
      return 'text';
    },
    openDeductAreaDialog(row, index) {
      this.deductAreaDialogVisible = true;
      this.currentDeductAreaIndex = index;
      // 解析jsonData
      this.tempDeductAreaList = row.jsonData ? JSON.parse(row.jsonData) : [];
      this.tempTotalDeductArea = row.subArea || "0.00";
      this.deductAreaForm = {
        typeIndex: 0,
        length: "",
        width: "",
        radius: "",
        base: "",
        height: "",
        customArea: "",
        area: "0.00",
        topBase: "",
        bottomBase: "",
        trapHeight: "",
      };
    },
    onDeductAreaDialogClose() {
      const index = this.currentDeductAreaIndex;
      if (index !== null && this.waterproofAreaList[index]) {
        this.waterproofAreaList[index].jsonData = JSON.stringify(this.tempDeductAreaList);
        this.waterproofAreaList[index].subArea = this.tempTotalDeductArea;
      }
      this.deductAreaDialogVisible = false;
      this.currentDeductAreaIndex = null;
    },
    onDeductAreaInput() {
      // 实时计算面积
      let form = this.deductAreaForm;
      let area = 0;
      switch (parseInt(form.typeIndex)) {
        case 0: // 矩形
          if (form.length && form.width) area = parseFloat(form.length) * parseFloat(form.width);
          break;
        case 1: // 圆形
          if (form.radius) area = Math.PI * Math.pow(parseFloat(form.radius), 2);
          break;
        case 2: // 三角形
          if (form.base && form.height) area = 0.5 * parseFloat(form.base) * parseFloat(form.height);
          break;
        case 3: // 梯形
          if (form.topBase && form.bottomBase && form.trapHeight)
            area = ((parseFloat(form.topBase) + parseFloat(form.bottomBase)) * parseFloat(form.trapHeight)) / 2;
          break;
        case 4: // 异形
          if (form.customArea) area = parseFloat(form.customArea);
          break;
      }
      this.deductAreaForm.area = isNaN(area) ? "0.00" : area.toFixed(2);
    },
    addDeductArea() {
      const form = this.deductAreaForm;
      const index = this.currentDeductAreaIndex;
      const areaItem = this.waterproofAreaList[index];
      const totalArea = parseFloat(areaItem.area); // 使用面积字段
      const currentDeductArea = this.tempDeductAreaList.reduce((sum, item) => sum + parseFloat(item.area), 0);
      const addArea = parseFloat(form.area);
      if (isNaN(totalArea) || totalArea <= 0) {
        this.$message.warning("请先填写有效的房间面积");
        return;
      }
      if (addArea <= 0) {
        this.$message.warning("请填写有效参数");
        return;
      }
      if (currentDeductArea + addArea > totalArea) {
        this.$message.warning("扣除面积不能大于当前项计算出来的面积");
        return;
      }
      let label = "";
      switch (parseInt(form.typeIndex)) {
        case 0:
          label = `矩形(长=${form.length},宽=${form.width},面积=${form.length}×${form.width}=${form.area})`;
          break;
        case 1:
          label = `圆形(半径=${form.radius},面积=π×${form.radius}²=${form.area})`;
          break;
        case 2:
          label = `三角形(底=${form.base},高=${form.height},面积=${form.base}×${form.height}/2=${form.area})`;
          break;
        case 3:
          label = `梯形(上底=${form.topBase},下底=${form.bottomBase},高=${form.trapHeight},面积=(${form.topBase}+${form.bottomBase})×${form.trapHeight}/2=${form.area})`;
          break;
        case 4:
          label = `异形(面积=${form.customArea})`;
          break;
      }
      if (parseFloat(form.area) <= 0) {
        this.$message.warning("请填写有效参数");
        return;
      }
      this.tempDeductAreaList.push({
        type: Number(form.typeIndex),
        label,
        area: form.area,
      });
      this.calcTempTotalDeductArea();
      // 重置表单
      this.deductAreaForm = {
        typeIndex: form.typeIndex,
        length: "",
        width: "",
        radius: "",
        base: "",
        height: "",
        customArea: "",
        area: "0.00",
        topBase: "",
        bottomBase: "",
        trapHeight: "",
      };
    },
    removeDeductArea(idx) {
      this.tempDeductAreaList.splice(idx, 1);
      this.calcTempTotalDeductArea();
    },
    calcTempTotalDeductArea() {
      const total = this.tempDeductAreaList.reduce((sum, item) => sum + parseFloat(item.area), 0);
      this.tempTotalDeductArea = total.toFixed(2);
    },
  }
};
</script>
<style lang="scss" scoped>
.table-container {
  padding: 8px 10px;
}
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
::v-deep .el-table--medium td {
  padding: 0 !important;
}
::v-deep .el-table {
  font-size: 12px !important;
}
::v-deep .el-form-item {
  margin-bottom: 0px !important;
}
::v-deep .el-table--medium th {
  padding: 0px !important;
}
::v-deep .el-table td .el-table th {
  padding: 0px !important;
}
</style>